exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".core[data-v-01885673]{width:100%;height:100%;position:relative}div[data-v-01885673]{box-sizing:border-box}.core .grid[data-v-01885673]{display:inline-block;vertical-align:top}.incorporated[data-v-01885673]{background:#20b2aa}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-01885673","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue-screen-layout.vue
// module id = 4
// module chunks = 0